<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить язык</span>
              <span v-else> <div>Добавить язык</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-text-field
              :error="hasError('name')"
              :error-messages="getError('name')"
              label="Язык"
              ref="number"
              required
              v-model="value.name"
            ></v-text-field>

            <v-checkbox
              label="Значение по умолчанию"
              ref="is_visible"
              v-model="value.default"
              :error="hasError('default')"
              :error-messages="getError('default')"
            ></v-checkbox>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

    import urls from "../../../../../modules/petition/urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'

    export default {
        name: "Language",
        mixins: [UserDataFormMixin],
        props: {
            id: Number,
            name: String,
            default: Boolean,
        },
        data() {
            return {
                URL_CREATE: urls.getUrl('admin|core|models|language-list', 'list'),
                URL_UPDATE:  urls.getUrl('admin|core|models|language-detail', 'update'),

                value: {
                    id: this.id || '',
                    name: this.name || '',
                    default: this.default || false,
                },
                // errors: {}
            }
        },
        methods: {
            closeDialog() {
                this.$emit('ended', '')
            },
        },
        created() {
        }
    }

</script>

<style scoped>

</style>
